import { PoposedToTheSubCommittee3ViewContainer } from "../../../containers/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee3ViewContainer";
export function PoposedToTheSubCommittee3ViewPage () {

    return(
        <PoposedToTheSubCommittee3ViewContainer/>
    )
}




